import {
  fetchFilterData,
  fetchRiList
} from '@/api/azure-reserved/azure-ri';



const getFilterData = (context, payload) => {
  context.commit('SET_IS_FILTER_DATA_LOADING', true);
  // console.log("##### getAzureFilterData >> payload",payload);
  fetchFilterData(payload).then((response) => {
    context.commit('SET_IS_FILTER_DATA_LOADING', false);
    context.commit('FILTER_DATA_UPDATED', response);
  }).catch((error) => {
    // eslint-disable-next-line
    context.commit('SET_IS_FILTER_DATA_LOADING', false);
    console.error(error);
  });
};


const getAzureRiList = (context, payload) => {
  context.commit('SET_IS_RI_LIST_LOADING', true);
  // console.log("##### getAzureRIList >> payload",payload);
  fetchRiList(payload).then((response) => {
    context.commit('SET_IS_RI_LIST_LOADING', false);
    context.commit('RI_LIST_UPDATED', response);
  }).catch((error) => {
    // eslint-disable-next-line
    context.commit('SET_IS_RI_LIST_LOADING', false);
    console.error(error);
  });
};


const selectedMonthToDate = (context, payload) => {
  context.commit('SET_ACTIVE_MONTH', payload);
};

const setDisplayedWarningBanner = (context, tabName) => {
  context.commit('SET_DISPLAYED_WARNING_BANNER', tabName);
}

const setSelectedViewByOption = (context, selectedViewBy) => {
  context.commit('SET_SELECTED_VIEW_BY_OPTION', selectedViewBy);
}

const setSelectedVendor = (context, selectedVendor) => {
  context.commit('SET_SELECTED_VENDOR', selectedVendor);
}

export default {
  getFilterData,
  getAzureRiList,
  setDisplayedWarningBanner,
  selectedMonthToDate,
  setSelectedViewByOption,
  setSelectedVendor
};



// WEBPACK FOOTER //
// ./src/store/modules/azure-reserved/azure-ri/actions.js